module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eLrUX"))).then(() => parcelRequire('cvs7o'));